/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getLists.defs'
export { main as default } from './getLists.defs'
